import missionService from "@/services/mission";

const mission = {
	namespaced: true,
  state: {
    currentPkClient: '',
    pathologies: '',
    missions: []
  },
  actions: {
    getMissions(store) {
      return new Promise((resolve, reject) => {
        missionService.getMissionEnCours().then(res => {
          if (res.success) {
            store.commit('SET_MISSIONS', res.data);
            resolve(res);
          } else {
            reject();
          }
        }).catch(err => {
          reject(err);
        })
      });
    },
    getPathologies(store, pkClient) {
      return new Promise((resolve, reject) => {
        missionService.getPathologies(pkClient).then(res => {
          if (res.success) {
            const pathologies = res.data.pathologies.map(item => item.pkPathology);
            store.commit('SET_PATHOLOGIES', pathologies.join(','));
            store.commit('SET_PK_CLIENT', pkClient);
            resolve(res);
          } else {
            store.commit('SET_PATHOLOGIES', '');
            store.commit('SET_PK_CLIENT', pkClient);
            resolve(true);
          }
        }).catch(err => {
          reject(err);
        })
      });
    }
  },
  mutations: {
    SET_MISSIONS: (state, missions) => {
      state.missions = missions;
    },
    SET_PATHOLOGIES: (state, pathologies) => {
      state.pathologies = pathologies;
    },
    SET_PK_CLIENT: (state, pkClient) => {
      state.currentPkClient = pkClient;
    }
  },
  getters: {
    pathologies: (state) => state.pathologies,
    currentPkClient: (state) => state.currentPkClient,
    missions: (state) => state.missions
  }
};

export default mission;
